import { AccountProvider } from "../Provider/AccountProvider";
import { QueryClientProvider } from "./QueryClientProvider";

export const QueryClient = () => {
	return (
		<QueryClientProvider>
			<AccountProvider />
		</QueryClientProvider>
	);
};
